import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import React from "react";
import { graphql, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type CreatePodcastWithTimestampElementButton_CreatePodcastWithTimestampElementMutation } from "@relay/CreatePodcastWithTimestampElementButton_CreatePodcastWithTimestampElementMutation.graphql";
import { type CreatePodcastWithTimestampElementButtonProps } from "./create-podcast-with-timestamp-element-button.interface";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

const CREATE_PODCAST_WITH_TIMESTAMP_ELEMENT_MUTATION = graphql`
	mutation CreatePodcastWithTimestampElementButton_CreatePodcastWithTimestampElementMutation(
		$input: CreatePodcastWithTimestampInput!
	) {
		Admin {
			ElearningV2 {
				createPodcastWithTimestampElement(input: $input) {
					eLearningContent {
						...contentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;

export const CreatePodcastWithTimestampElementButton = ({
	eLearningContentId,
}: CreatePodcastWithTimestampElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createPodcastWithTimestampElement, isCreatingPodcastWithTimestampElement] =
		useMutation<CreatePodcastWithTimestampElementButton_CreatePodcastWithTimestampElementMutation>(
			CREATE_PODCAST_WITH_TIMESTAMP_ELEMENT_MUTATION,
		);

	return (
		<Button
			disabled={isCreatingPodcastWithTimestampElement}
			tooltip={t("educationalOffer.createPodcastWithTimestampTooltip")}
			icon={EpicIcons.MICROPHONE}
			onClick={() => {
				createPodcastWithTimestampElement({
					variables: {
						input: {
							title: t("educationalOffer.newElement"),
							podcastFileId: undefined,
							timestampsWithImage: [],
							eLearningContentId,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
